(ns client-portal.client.voice-insights.locations.views
  (:require [client-portal.client.layout :as l]
            [shared.core.components.components :as c]
            [shared.core.amelia-light.components.components :as alc]
            [shared.core.reactive :as re]
            [shared.core.style :as style]
            [client-portal.client.components.analytics :as cp.c]
            [client-portal.client.voice-insights.data :as vi.d]
            [client-portal.client.voice-insights.shared :as vi.shared]
            [client-portal.client.voice-insights.locations.data :as locations.d]
            [client-portal.client.voice-insights.tag-data :as tag.d]
            [client-portal.client.vi.components.tag :as tag]
            [client-portal.client.audio.views :as audio]
            [goog.string :as s]
            [shared.core.time :as t]
            [shared.core.util :as util]))

(def session-filter-height 56)

(defn score-tag [{:keys [score style]}]
  (let [color (cond
                (< score 25) (style/color :red :shade-7)
                (< score 75) (style/color :orange :shade-4)
                :else (style/color :green :shade-9))]
    [:div {:style {:display :flex
                   :align-items :center
                   :justify-content :center
                   :width :fit-content
                   :padding "0px 12px"
                   :border-radius 8
                   :background-color (util/hex->rgba color 0.3)
                   :min-width 38}}
     [:span {:style (merge {:font-family style/roboto-font-family
                            :font-size 12
                            :line-height "18px"
                            :font-weight style/font-regular-weight
                            :color (util/hex->rgba (style/color :black :base) 0.8)}
                           style)}
      score]]))

(defn tag-material-icon [{:keys [tags name size] :or {size 16}}]
  (let [tag (first (filter #(s/includes? (:name %) name) tags))
        tag-value (:value tag)]
    (if tag-value
      (cond
        (#{"size-upsell" "combo-upsell" "add-on-upsell"} name)
        [c/material-icon
         (case tag-value
           "offered" {:icon-type :check
                      :style {:color (style/color :green :shade-8)
                              :font-size size}}
           {:icon-type :close
            :style {:color (style/color :red :shade-6)
                    :font-size size}})]

        (#{"greeting" "sentiment"} name)
        (case tag-value
          "positive" [:svg {:width size :height size :view-box "0 0 16 16"}
                      [:use {:xlink-href "/images/sentiment.svg"}]]
          "negative" [:svg {:width size :height size :view-box "32 0 16 16"}
                      [:use {:xlink-href "/images/sentiment.svg"}]]
          [:svg {:width size :height size :view-box "16 0 16 16"}
           [:use {:xlink-href "/images/sentiment.svg"}]]))
      [:span ""])))

(defn filter-pair [{:keys [index]}]
  (let [filter-data @(re/subscribe [:locations/filter-data-])
        filter-pair (get filter-data index)
        filter-by (:by filter-pair)
        filter-by-options [{:value "store-id" :text "Store ID"}]]
    [:div {:style {:display :flex
                   :align-items :center
                   :gap 12}}
     [:div {:style {:flex 1}}
      [c/dropdown {:placeholder "Filter by"
                   :value (:by filter-pair)
                   :on-change (fn [_ d]
                                (let [v (aget d "value")]
                                  (re/dispatch [:locations/update-filter-pair index :by v])))
                   :container-style {:width "100%"}
                   :options filter-by-options
                   :style {:height 24
                           :background-color (style/color :white :base)
                           :align-items :center
                           :font-size 12}}]]
     [:div {:style {:width 90}}
      [c/dropdown {:placeholder "Condition"
                   :value (:condition filter-pair)
                   :on-change (fn [_ d]
                                (let [v (aget d "value")]
                                  (re/dispatch [:locations/update-filter-pair index :condition v])))
                   :container-style {:width "100%"}
                   :options [{:value "<" :text "<"}
                             {:value "<=" :text "<="}
                             {:value "=" :text "="}
                             {:value ">=" :text ">="}
                             {:value ">" :text ">"}]
                   :style {:height 24
                           :background-color (style/color :white :base)
                           :align-items :center
                           :font-size 12}}]]
     (when (contains? #{"include" "exclude"} (:condition filter-pair))
       [:div {:style {:width 80}}
        [c/dropdown {:placeholder "Any / All"
                     :value (:join filter-pair)
                     :on-change (fn [_ d]
                                  (let [v (aget d "value")]
                                    (re/dispatch [:locations/update-filter-pair index :join v])))
                     :container-style {:width "100%"}
                     :options [{:value "or" :text "Any Of"}
                               {:value "and" :text "All Of"}]
                     :style {:height 24
                             :background-color (style/color :white :base)
                             :align-items :center
                             :font-size 12}}]])
     [:div {:style {:flex 1}}
      (when filter-by
        (let [filter-by-text (->> filter-by-options
                                  (filter #(= (:value %) filter-by))
                                  (first)
                                  :text)]
          [:<>
           [:style
            "input::placeholder {
                                  color: rgba(0, 0, 0, 0.4);}"]
           [:input {:type :text
                    :style {:font-family style/roboto-font-family
                            :font-size 12
                            :line-height "18px"
                            :font-weight style/font-regular-weight
                            :color (style/color :black :base)
                            :padding "3px 6px"
                            :border "1px solid rgba(0, 0, 0, 0.2)"
                            :border-radius 3
                            :outline "none"
                            :background-color "transparent"
                            :width 135}
                    :placeholder filter-by-text
                    ;;  :on-change #(re/dispatch [:sessions/filter-conversations (-> % .-target .-value)])
                    }]]))]
     [:div {:style {:flex "0 0 auto"
                    :display :flex
                    :align-items :center}}
      [c/material-icon {:icon-type :delete
                        :style {:color (util/hex->rgba (style/color :black :base) 0.3)
                                :cursor :pointer
                                :font-size 16}
                        :on-click #(re/dispatch [:locations/delete-filter-data-index index])}]]]))

(defn filter-popover []
  (let [filter-data @(re/subscribe [:locations/filter-data-])]
    [:div {:style {:background-color (style/color :white :base)
                   :border (str "1px solid " (util/hex->rgba (style/color :black :base) 0.12))
                   :border-radius 2
                   :box-shadow "0 2px 4px 0 rgba(0, 0, 0, 0.03), 0 6px 18px 0 rgba(0, 0, 0, 0.08)"
                   :z-index 1000
                   :padding 16
                   :display :flex
                   :flex-direction :column
                   :gap 12
                   :width 438}}
     [:div {:style {:display :flex
                    :align-items :center
                    :justify-content :space-between}}
      [:span {:style {:font-family style/roboto-font-family
                      :font-size 12
                      :line-height "18px"
                      :font-weight style/font-regular-weight
                      :color (util/hex->rgba (style/color :black :base) 0.4)}}
       "Filter"]
      [c/interactive
       :div {:style {:cursor :pointer}
             :on-click #(re/dispatch [:locations/close-filter-popover])}
       [c/material-icon {:icon-type :close
                         :style {:font-size 14}}]]]
     [:div {:style {:display :flex
                    :flex-direction :column
                    :gap 8}}
      (into [:<>]
            (map-indexed (fn [idx _]
                           [filter-pair {:index idx}])
                         filter-data))]
     [:div {:style {:display :flex
                    :align-items :center
                    :justify-content :space-between}}
      [c/interactive
       :div {:style {:display :flex
                     :align-items :center
                     :gap 6
                     :padding "3px 18px 3px 6px"
                     :cursor :pointer}
             :on-click #(re/dispatch [:locations/add-filter-pair])}
       [c/material-icon {:icon-type :add
                         :style {:font-size 14
                                 :color (style/color :blue :shade-1)}}]
       [:span {:style {:font-family style/roboto-font-family
                       :font-size 12
                       :line-height "18px"
                       :font-weight style/font-regular-weight
                       :color (style/color :blue :shade-1)}}
        "Add a New Filter"]]
      [c/blue-button {:style {:font-family style/roboto-font-family
                              :font-size 12
                              :line-height "18px"
                              :font-weight style/font-regular-weight
                              :height :auto
                              :padding "3px 18px"
                              :border-radius 3}
                      :on-click #(do
                                   (re/dispatch [:locations/close-filter-popover])
                                   (re/dispatch [:locations/apply-filters]))}
       "Apply"]]]))

(defn filter-button []
  [alc/tooltip
   {:id "locations-filter-tooltip"
    :placement :bottom-start
    :arrow? false
    :max-width nil
    :interactive? true
    :theme? false
    :append-to js/document.body
    :tooltip-container-style {:background-color (style/color :white :base)
                              :padding 0}
    :show-on-click? true
    :tooltip-content [filter-popover]
    :target-content [:div {:id :add-filter-button
                           :style {:cursor :pointer
                                   :display :flex
                                   :align-items :center
                                   :gap 6
                                   :height 32
                                   :padding "3px 18px 3px 6px"
                                   :border-radius 3
                                   :border "1px solid rgba(0, 0, 0, 0.2)"}}
                     [c/material-icon {:icon-type :filter-alt
                                       :style {:font-size 14
                                               :color (util/hex->rgba (style/color :black :base) 0.8)}}]
                     [:span {:style {:display :inline-block
                                     :padding 0
                                     :font-family style/roboto-font-family
                                     :font-size 12
                                     :line-height "18px"
                                     :font-weight style/font-regular-weight
                                     :color (util/hex->rgba (style/color :black :base) 0.8)
                                     :margin-left 5}}
                      "Add Filter"]]}])

(defn locations-header
  []
  [:div {:style {:display :flex
                 :align-items :center
                 :justify-content :space-between
                 :padding "24px 24px 20px"}}
   [:span {:style {:font-family style/roboto-font-family
                   :font-size 20
                   :line-height "32px"
                   :font-weight style/font-semi-bold-weight
                   :color (util/hex->rgba (style/color :on-background :base) 0.8)}}
    "All locations"]])

(defn locations-filter
  [{:keys [concept-id]}]
  (let [container-id "locations-filter-container"
        locations- (re/subscribe [:locations/list- {:concept-id concept-id}])
        vs- (re/subscribe [:core/viewport-size])
        set-filter-height #(when-let [container-height (some-> (js/document.getElementById container-id)
                                                               (.getBoundingClientRect)
                                                               (.-height))]
                             (re/dispatch [:locations/set-filter-container-height container-height]))]
    (re/create-class
      {:component-did-mount
       set-filter-height

       :component-did-update
       set-filter-height

       :reagent-render
       (fn []
         @vs-
         (let [locations-loading? (util/loading? @locations-)
               locations-count (when (not locations-loading?) (count @locations-))]
           (if locations-loading?
             [:div {:id container-id
                    :style {:padding 12}}
              [c/loader-rectangle {:height 32}]]
             [:div {:id container-id
                    :style {:background-color (style/color :white :base)
                            :display :flex
                            :flex-direction :column
                            :gap 16
                            :width "100%"
                            :padding 16
                            :position :sticky
                            :top 0
                            :left 0
                            :z-index (style/z :medium)}}
              [:div {:style {:display :flex
                             :align-items :center
                             :justify-content :space-between}}
               [:div {:style {:display :flex
                              :align-items :center
                              :justify-content :space-between}}
                [:span {:style {:font-family style/roboto-font-family
                                :font-size 14
                                :line-height "20px"
                                :font-weight style/font-medium-weight
                                :color (util/hex->rgba (style/color :on-background :base) 0.4)}}
                 (when-not locations-loading?
                   (str (some-> locations-count (util/readable-number))
                        " "
                        (util/pluralize "Result" locations-count)))]]
               [:div {:style {:display :flex
                              :align-items :center
                              :justify-content :space-between}}
                [:div {:style {:display :flex
                               :align-items :center
                               :gap 8}}
                 [filter-button]]]]])))})))

(defn locations-list [{:keys [concept-id]}]
  (let [locations- (re/subscribe [:locations/list- {:concept-id concept-id}])
        loading? (util/loading? @locations-)
        locations-by-concept-id- (re/subscribe [:locations/by-current-concept-id-])
        location-id->label- (re/subscribe [:locations/location-id->label-by-current-concept-id-])
        ;; filter-container-height- (re/subscribe [:locations/filter-container-height-])
        ]
    [alc/table {:scroll-container-id l/core-scroll-content-id
                :container-loading? (or loading? (util/loading? @locations-by-concept-id-))
                :loading? loading?
                :loading-label "Loading locations..."
                :no-data-text "No locations to display"
                :has-more? false
                :flex-vals [63 {:flex 1} 85 85 100 90 88 96 128]
                :header-top session-filter-height           ;; (or @filter-container-height- session-filter-height)
                :headers ["Store ID"
                          "Address"
                          "Marketing"
                          "Efficiency"
                          "Satisfaction"
                          "Conversations"
                          "Avg Duration"
                          "Crew Utterances"
                          "Customer Utterances"]
                :rows (map (fn [{:keys [location-id scores utterances conversation-count duration]}]
                             {:cells [location-id
                                      {:label (get @location-id->label- (util/parse-int location-id))
                                       :style {:font-family style/roboto-font-family
                                               :font-size 12
                                               :line-height "18px"
                                               :font-weight style/font-regular-weight
                                               :color (style/color :blue :shade-1)}}
                                      [score-tag {:score (some->> (vi.d/matches-category "marketing" scores)
                                                                  (first)
                                                                  :score)}]
                                      [score-tag {:score (some->> (vi.d/matches-category "efficiency" scores)
                                                                  (first)
                                                                  :score)}]
                                      [score-tag {:score (some->> (vi.d/matches-category "satisfaction" scores)
                                                                  (first)
                                                                  :score)}]
                                      conversation-count
                                      (t/seconds->format duration)
                                      (some->> (filter #(= (:speaker %) "crew") utterances)
                                               (first)
                                               :avg-utterances
                                               (s/format "%.2f"))
                                      (some->> (filter #(= (:speaker %) "user") utterances)
                                               (first)
                                               :avg-utterances
                                               (s/format "%.2f"))]
                              :hover-style {}})
                           @locations-)}]))

(defn root [_]
  (re/create-class
    ;; TODO: Fix me
    {:component-did-mount (fn [this]
                            (re/dispatch [:voice-insights/initialize])
                            (re/dispatch [:locations/initialize-filters]))
     :reagent-render
     (fn [{:keys [cid] :as args}]
       [l/logged-in-with-header-nav-vi (merge args {:concept-dropdown? true})
        (when (not-empty cid)
          [:div {:style {:display :flex
                         :flex-direction :column
                         :width "100%"
                         :min-height "100%"}}
           [locations-header]
           [locations-filter {:concept-id (util/parse-int cid)}]
           [locations-list {:concept-id (util/parse-int cid)}]])])}))
